/* MT — scripts propios (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  /* ---------- Animaciones de entrada + contadores ---------- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    if (reduceMotion) { el.textContent = target; return; }
    var duration = 1400;
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initReveal() {
    var items = document.querySelectorAll('.mt-reveal:not(.mt-visible), [data-count]:not([data-counted])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach(function (el) {
        el.classList.add('mt-visible');
        if (el.hasAttribute('data-count')) { el.setAttribute('data-counted', '1'); countUp(el); }
      });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.classList.add('mt-visible');
          if (el.hasAttribute('data-count') && !el.hasAttribute('data-counted')) {
            el.setAttribute('data-counted', '1');
            countUp(el);
          }
          observer.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Hero: entrada suave + parallax ---------- */
  function initHero() {
    document.querySelectorAll('.mt-hero').forEach(function (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-ready'); });
      var img = hero.querySelector('.mt-hero__media img');
      var k = parseFloat(hero.getAttribute('data-parallax')) || 0;
      if (!img || !k || reduceMotion || hero.hasAttribute('data-parallax-init')) return;
      hero.setAttribute('data-parallax-init', '1');
      var ticking = false;
      function update() {
        ticking = false;
        if (window.innerWidth < 990) { img.style.transform = ''; return; }
        var y = Math.min(window.scrollY, hero.offsetHeight * 1.2);
        img.style.transform = 'translate3d(0,' + (y * k / 100).toFixed(1) + 'px,0) scale(1.04)';
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct() {
    document.querySelectorAll('[data-mt-product]').forEach(function (root) {
      if (root.hasAttribute('data-mt-init')) return;
      root.setAttribute('data-mt-init', '1');

      /* Galería */
      var main = root.querySelector('[data-gallery-main]');
      var thumbs = root.querySelectorAll('[data-thumb]');

      function mostrarImagen(src, alt) {
        if (!main || !src) return;
        if (main.src === src) return;
        main.classList.add('is-swapping');
        setTimeout(function () {
          main.src = src;
          main.alt = alt || '';
          main.removeAttribute('srcset');
          main.classList.remove('is-swapping');
        }, 180);
        // marcar la miniatura que corresponde
        thumbs.forEach(function (b) {
          var suya = b.getAttribute('data-src') === src;
          b.classList.toggle('is-active', suya);
          b.setAttribute('aria-current', suya ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          mostrarImagen(btn.getAttribute('data-src'), btn.getAttribute('data-alt'));
        });
      });

      /* Cantidad */
      var qtyInput = root.querySelector('[data-qty-input]');
      root.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          var v = parseInt(qtyInput.value, 10) || 1;
          v += parseInt(b.getAttribute('data-qty'), 10);
          qtyInput.value = Math.max(1, v);
        });
      });

      /* Variantes */
      var json = root.querySelector('[data-variants-json]');
      if (!json) return;
      var variants;
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      var idInput = root.querySelector('input[name="id"]');
      var priceNow = root.querySelector('[data-price-now]');
      var priceWas = root.querySelector('[data-price-was]');
      var addBtn = root.querySelector('[data-add-btn]');
      var addLabel = root.querySelector('[data-add-label]');
      var labels = root.querySelectorAll('[data-option-value]');
      var addText = addBtn ? addBtn.getAttribute('data-text-add') : '';
      var soldText = addBtn ? addBtn.getAttribute('data-text-sold') : '';

      function currentOptions() {
        var chosen = [];
        root.querySelectorAll('[data-option-group]').forEach(function (g) {
          var checked = g.querySelector('input:checked');
          chosen.push(checked ? checked.value : null);
        });
        return chosen;
      }
      function update() {
        var chosen = currentOptions();
        var match = variants.filter(function (v) {
          return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
        })[0];
        labels.forEach(function (l) {
          var i = parseInt(l.getAttribute('data-option-value'), 10);
          if (chosen[i]) l.textContent = chosen[i];
        });
        if (!match) {
          if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); }
          if (addLabel) addLabel.textContent = soldText;
          return;
        }
        if (idInput) {
          idInput.value = match.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (priceNow) priceNow.textContent = match.price;
        if (priceWas) {
          if (match.compare) { priceWas.textContent = match.compare; priceWas.hidden = false; }
          else { priceWas.hidden = true; }
        }
        if (addBtn) {
          if (match.available) { addBtn.removeAttribute('disabled'); if (addLabel) addLabel.textContent = addText; }
          else { addBtn.setAttribute('disabled', 'disabled'); if (addLabel) addLabel.textContent = soldText; }
        }
        if (match.image) mostrarImagen(match.image, match.imageAlt);
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }
      root.querySelectorAll('[data-option-group] input').forEach(function (i) {
        i.addEventListener('change', update);
      });
    });
  }

  /* ---------- FAQ: solo una abierta ---------- */
  function initFaq() {
    document.querySelectorAll('[data-mt-faq]').forEach(function (list) {
      if (list.hasAttribute('data-mt-init')) return;
      list.setAttribute('data-mt-init', '1');
      list.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        list.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }

  function init() { initReveal(); initHero(); initProduct(); initFaq(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Editor de Shopify: al recargar una sección, reiniciar */
  document.addEventListener('shopify:section:load', function () { init(); });
})();
